(ns common.schema.entities.decision-options
  (:require
   [common.schema.entities.common.options :as common-options]))

(def ic-approval-options
  [{:key   :condition.status/true
    :label "Approves"}
   {:key   :condition.status/conditionally-true
    :label "Conditionally approves"}
   {:key   :condition.status/postponed
    :label "Decision postponed"}
   {:key   :condition.status/false
    :label "Rejects"}])

(def approval-status-options
  [{:value :decision.status/approved
    :label "Approved"}
   {:value :decision.status/conditionally-approved
    :label "Conditionally approved"}
   {:value :decision.status/rejected
    :label "Rejected"}])

(def lookup
  (merge (->> common-options/condition-true-false-options
              (map (fn [o]
                     [(:key o) (:label o)]))
              (into {}))
         (->> ic-approval-options
              (map (fn [o]
                     [(:key o) (:label o)]))
              (into {}))))


(defn get-label
  [k]
  (get lookup k))
